// extracted by css-extract-rspack-plugin
export default {"cls1":"SmallAccountMenuButton-cls1_abJ","cls2":"SmallAccountMenuButton-cls2_85f SmallAccountMenuButton-cls1_abJ"};